<template>
  <div class="tmb tmb-iso-w4 tmb-iso-h4 tmb-light tmb-content-left tmb-image-anim tmb-bordered  grid-cat-1169 grid-cat-28 grid-cat-1145 tmb-id-123206 tmb-content-under tmb-media-first tmb-no-bg tmb-iso">
    <div class="t-inside animate_when_almost_visible bottom-t-top start_animation">
      <div class="t-entry-visual">
        <div class="t-entry-visual-tc">
          <div class="t-entry-visual-cont">
            <div class="dummy" style="padding-top: 45.8%;"></div>
            <a tabindex="-1" :href="event.attributes.url" class="pushed" target="_self" data-lb-index="0">
              <div class="t-entry-visual-overlay">
                <div class="t-entry-visual-overlay-in style-dark-bg" style="opacity: 0.5;"></div>
              </div>
              <div class="t-overlay-wrap">
                <div class="t-overlay-inner">
                  <div class="t-overlay-content">
                    <div class="t-overlay-text single-block-padding">
                      <div class="t-entry t-single-line"></div>
                    </div>
                  </div>
                </div>
              </div>
              <img :src="event.attributes.image" width="600" height="275" alt=""></a>
          </div>
        </div>
      </div>
      <div class="t-entry-text">
        <div class="t-entry-text-tc single-block-padding">
          <div class="t-entry"><p class="t-entry-meta">
            <span class="t-entry-date">{{ statingDate }} - {{ endingDate }}</span>
          </p>
            <p class="t-entry-meta">
              <span class="t-entry-category"></span>
              <span class="t-entry-category"></span>
              <span class="t-entry-category t-entry-tax">
                <a :href="category.attributes.url">{{ category.attributes.name }}</a>
              </span>
            </p>
            <h3 class="t-entry-title h3">
              <a :href="event.attributes.url" target="_self">{{ event.attributes.title }}</a>
            </h3>
            <div class="t-entry-excerpt "></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Event } from "@/domain/events/event";
import { computed } from "vue";

interface Props {
  event: Event;
}

const props = defineProps<Props>();

function formatDate(date: string): string {
  return Intl.DateTimeFormat('en-US', {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  }).format(new Date(date));
}

const category = computed(() => props.event.relationships.category.shift());
const statingDate = computed(() => formatDate(props.event.attributes.starting_date));
const endingDate = computed(() => formatDate(props.event.attributes.ending_date));
</script>

<style scoped lang="scss">
  .tmb {
    width: 33%;

    @media (max-width: 780px) {
      width: 100%;
    }
  }
</style>
